/* Generated from snippets/dd-custom.liquid. Served from the Shopify CDN and
   loaded with `defer` so it is cached across navigations and no longer ships
   ~29 KB of inline JS inside every HTML response. `defer` runs it after the
   document is parsed but before DOMContentLoaded, which is exactly when the
   old inline version ran. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function safe(name, fn) {
    try { fn(); } catch (e) { console.warn('dd: block "' + name + '" failed —', e); }
  }

  ready(function () {

    /* ---------------- viewport / page gating ---------------- */
    safe('viewport', function () {
      var MOBILE_BP = 990;
      function isHome() {
        return document.body.classList.contains('homepage') || location.pathname === '/' || location.pathname === '';
      }
      function isMobile() { return window.innerWidth < MOBILE_BP; }

      /* ANTI-FLASH FIX
         --------------
         This block used to do two things on DOMContentLoaded:
           1. toggle .dd-is-home / .dd-is-mobile / .dd-show-custom-header on <body>,
              which is what actually hid the original theme header, and
           2. physically move #dd-header (and the announce bar / footer) from the
              bottom of <body> up to the top.
         Both ran only AFTER every deferred script had executed, so each page load
         painted the ORIGINAL theme first and then snapped to the custom design.

         Both jobs are now done before the first paint:
           1. the gating is pure CSS (media queries + the server-rendered
              `homepage` body class) — see snippets/dd-custom-css.liquid,
           2. #dd-header is rendered in its final position by theme.liquid —
              see snippets/dd-custom-header.liquid.
         The classes are still applied below so any third-party CSS or app that
         happens to key off them keeps working; nothing in this theme needs them. */
      function apply() {
        var b = document.body;
        b.classList.toggle('dd-is-home', isHome());
        b.classList.toggle('dd-is-mobile', isMobile());
        b.classList.toggle('dd-show-custom-header', !isMobile());
      }
      apply();
      window.addEventListener('resize', apply, { passive: true });
      document.addEventListener('dd:recheck', apply);
    });

        /* ---------------- Wizzy in-page search guard ----------------
       Wizzy does not reload the page when you search from the home page: it
       swaps its results into <main> and rewrites the URL to /pages/search?q=…
       via history.pushState. The custom home sections are rendered AFTER
       </main> in layout/theme.liquid, so they survive the swap and show up
       underneath the search results. Flag the state on <html> and let
       assets/dd-custom.css hide them. */
    safe('wizzy-search-guard', function () {
      /* The sections only exist on the home page — nothing to guard elsewhere. */
      if (!document.body.classList.contains('homepage')) return;

      var root = document.documentElement;
      var SEL  = '.wizzy-search-wrapper, .wizzy-search-results-wrapper, #wizzy-search-container';

      function visible(el) { return !!(el && el.getClientRects().length); }

      function searchActive() {
        if (visible(document.querySelector(SEL))) return true;
        return location.pathname.indexOf('/pages/search') === 0;
      }

      function sync() { root.classList.toggle('dd-search-active', searchActive()); }

      sync();

      /* pushState fires no event — patch it so we see Wizzy's URL rewrite. */
      ['pushState', 'replaceState'].forEach(function (m) {
        var orig = history[m];
        if (typeof orig !== 'function') return;
        history[m] = function () {
          var r = orig.apply(this, arguments);
          sync();
          return r;
        };
      });
      window.addEventListener('popstate', sync);
      window.addEventListener('pageshow', sync);

      /* Catches results being rendered or torn down without a URL change.
         Scoped to <main> and debounced, so it costs nothing while idle. */
      var main = document.getElementById('MainContent');
      if (main && window.MutationObserver) {
        var t = null;
        new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(sync, 120);
        }).observe(main, { childList: true, subtree: true });
      }
    });

    /* ---------------- hero slider ---------------- */
    safe('hero-slider', function () {
      var hero = document.getElementById('dd-hero');
      if (!hero) return;
      var slideEls = hero.querySelectorAll('.dd-slide');
      var dotEls = hero.querySelectorAll('.dd-dot');
      var idx = 0, timer = null, DELAY = 5000;
      function show(n) {
        idx = (n + slideEls.length) % slideEls.length;
        slideEls.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
        dotEls.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      }
      function next() { show(idx + 1); }
      function start() { stop(); timer = setInterval(next, DELAY); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      hero.querySelectorAll('.dd-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () { show(idx + Number(btn.dataset.dir)); start(); });
      });
      dotEls.forEach(function (dot) {
        dot.addEventListener('click', function () { show(Number(dot.dataset.i)); start(); });
      });
      start();
    });

    /* ---------------- category flyout (desktop hover) ---------------- */
    safe('hero-flyout', function () {
      var hero = document.getElementById('dd-hero');
      if (!hero) return;
      var sidebar = hero.querySelector('.dd-sidebar');
      var cats = hero.querySelectorAll('.dd-cat');
      var layer = hero.querySelector('.dd-flyout-layer');
      var panel = hero.querySelector('.dd-flyout');
      if (!sidebar || !layer || !panel) return;
      var panes = panel.querySelectorAll('.dd-fly-pane');

      function openFly(i, catEl) {
        panes.forEach(function (p) { p.style.display = (p.dataset.pane === String(i)) ? 'block' : 'none'; });
        if (!panel.querySelector('.dd-fly-pane[style*="block"]')) { return; }
        hero.classList.add('dd-fly-open');
        cats.forEach(function (c) { c.classList.toggle('is-hover', c.dataset.cat === String(i)); });
        var banner = hero.querySelector('.dd-banner');
        if (banner && catEl) {
          var top = catEl.getBoundingClientRect().top - banner.getBoundingClientRect().top;
          var maxTop = banner.clientHeight - panel.offsetHeight - 12;
          if (maxTop < 0) maxTop = 0;
          panel.style.top = Math.max(0, Math.min(top, maxTop)) + 'px';
        }
      }
      function closeFly() {
        hero.classList.remove('dd-fly-open');
        cats.forEach(function (c) { c.classList.remove('is-hover'); });
      }
      cats.forEach(function (c) {
        c.addEventListener('mouseenter', function () {
          var i = c.dataset.cat;
          var hasPane = panel.querySelector('.dd-fly-pane[data-pane="' + i + '"]');
          if (!hasPane) { closeFly(); return; }
          openFly(i, c);
        });
      });
      sidebar.addEventListener('mouseleave', function (e) { if (!layer.contains(e.relatedTarget)) closeFly(); });
      layer.addEventListener('mouseleave', function (e) { if (!sidebar.contains(e.relatedTarget)) closeFly(); });
    });

    /* ---------------- mega menu ---------------- */
    safe('mega', function () {
      var header = document.getElementById('dd-header');
      var mega = document.getElementById('ddMega');
      if (!header || !mega) return;
      var deptBtns = mega.querySelectorAll('.dd-mega-dept');
      var panes = mega.querySelectorAll('.dd-mega-pane');

      function renderPanel(i) {
        panes.forEach(function (p) { p.classList.toggle('is-active', p.dataset.mpane === String(i)); });
        deptBtns.forEach(function (b) { b.classList.toggle('active', b.dataset.i === String(i)); });
      }
      deptBtns.forEach(function (b) {
        b.addEventListener('mouseenter', function () { renderPanel(b.dataset.i); });
        b.addEventListener('click', function () {
          var pane = mega.querySelector('.dd-mega-pane[data-mpane="' + b.dataset.i + '"]');
          var link = pane ? pane.querySelector('.dd-mega-viewall') : null;
          if (link) window.location.href = link.getAttribute('href');
        });
      });

      var closeTimer = null;
      function openMega(i) {
        clearTimeout(closeTimer);
        if (typeof i !== 'undefined') renderPanel(i);
        header.classList.add('dd-mega-open');
      }
      function closeMega() {
        closeTimer = setTimeout(function () { header.classList.remove('dd-mega-open'); }, 120);
      }

      var shopcat = document.getElementById('ddShopCatBtn');
      if (shopcat) {
        shopcat.addEventListener('mouseenter', function () { openMega(0); });
        shopcat.addEventListener('click', function (e) { e.preventDefault(); openMega(0); });
      }

      function findDeptIndexByLabel(label) {
        label = (label || '').trim().toLowerCase();
        var found = -1;
        deptBtns.forEach(function (b, idx) {
          var lbl = b.querySelector('.dd-mega-dlabel');
          if (lbl && lbl.textContent.trim().toLowerCase() === label) found = b.dataset.i;
        });
        return found;
      }
      header.querySelectorAll('.dd-hd-link').forEach(function (link) {
        var idxFound = findDeptIndexByLabel(link.textContent);
        if (idxFound === -1) return;
        var wrap = link.closest('.dd-hd-has-menu');
        if (wrap) wrap.classList.add('dd-mega-linked');
        link.addEventListener('mouseenter', function () { openMega(idxFound); });
      });

      var navBar = header.querySelector('.dd-hd-nav');
      [navBar, mega].forEach(function (zone) {
        if (!zone) return;
        zone.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        zone.addEventListener('mouseleave', function () { closeMega(); });
      });
    });

    /* ---------------- FAQ accordion ---------------- */
    safe('faq', function () {
      var list = document.getElementById('ddFaqList');
      if (!list) return;
      var items = list.querySelectorAll('.dd-faq-item');
      items.forEach(function (item) {
        var btn = item.querySelector('.dd-faq-q');
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            other.querySelector('.dd-faq-q').setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
    });

    /* ---------------- sticky header shadow ---------------- */
    safe('sticky', function () {
      var el = document.getElementById('dd-header');
      if (!el) return;
      window.addEventListener('scroll', function () {
        el.classList.toggle('is-stuck', window.pageYOffset > 10);
      }, { passive: true });
    });

        /* ---------------- search placeholder typing animation ---------------- */
safe('placeholder-typing', function () {
  var input = document.getElementById('ddHdInput');
  if (!input || !input.setAttribute) return;

  var PREFIX = 'Search For ';          /* stays fixed */
  var WORDS = [
    'Home Decor',
    'Office & Stationery',
    'Health & Beauty',
    'Fashion & Jewellery',
    'Kitchen'
  ];
  var STATIC_FALLBACK = 'Search 50,000+ products jewellery, kitchen, gifts…';

  var TYPE_MS = 200;     /* typing speed (matches the recording) */
  var DELETE_MS = 100;   /* deleting speed */
  var HOLD_MS = 1200;    /* pause on the completed phrase */
  var GAP_MS = 500;      /* pause on empty "Search For " before next phrase */

  /* reduced-motion users get a plain static placeholder */
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      input.placeholder = STATIC_FALLBACK;
      return;
    }
  } catch (e) {}

  var w = 0, i = 0, deleting = false, stopped = false;

  function bail() {
    stopped = true;
    try { input.placeholder = STATIC_FALLBACK; } catch (e) {}
  }

  function tick() {
    if (stopped) return;
    try {
      /* input removed from the page → stop cleanly */
      if (!document.body.contains(input)) { stopped = true; return; }

      /* pause while the user is focused on the field or has typed something */
      if (input.value) {
        input.placeholder = STATIC_FALLBACK;
        setTimeout(tick, 600);
        return;
      }

      var word = WORDS[w % WORDS.length];

      if (!deleting) {
        i++;
        input.placeholder = PREFIX + word.slice(0, i);
        if (i >= word.length) {
          deleting = true;
          setTimeout(tick, HOLD_MS);
        } else {
          setTimeout(tick, TYPE_MS);
        }
      } else {
        i--;
        input.placeholder = PREFIX + word.slice(0, i);
        if (i <= 0) {
          deleting = false;
          w++;
          setTimeout(tick, GAP_MS);
        } else {
          setTimeout(tick, DELETE_MS);
        }
      }
    } catch (e) { bail(); }
  }

  setTimeout(tick, 800);
});

      /* ---------------- cart icon: open the real cart ----------------
       */
    safe('cart-open-drawer', function () {
      var WAIT_MS = 2000;

      var ddCart = document.querySelector('.dd-hd-cart');
      if (!ddCart) return;

      function openGokwik() {
        if (typeof window.openGokwikSideCart === 'function') {
          try { window.openGokwikSideCart(); return true; } catch (e) {}
        }
        return false;
      }

      ddCart.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

        /* no GoKwik on the page at all → let href="/cart" do its thing */
        if (!document.querySelector('shadow-dom-container') &&
            typeof window.openGokwikSideCart !== 'function') return;

        e.preventDefault();

        if (openGokwik()) return;

        /* not ready yet — poll briefly instead of navigating */
        var started = Date.now();
        var t = setInterval(function () {
          if (openGokwik() || Date.now() - started > WAIT_MS) clearInterval(t);
        }, 100);
      });
    });

    /* ---------------- live cart count + total ---------------- */
    safe('cart-count', function () {
      var el = document.getElementById('dd-header');
      if (!el) return;
      function refreshCart() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var countEl = document.getElementById('ddHdCount');
            var totalEl = document.getElementById('ddHdTotal');
            if (countEl) countEl.textContent = c.item_count;
            if (totalEl) totalEl.textContent = 'Rs. ' + (c.total_price / 100).toFixed(2);
          })
          .catch(function () {});
      }
      refreshCart();
      document.addEventListener('dd:cart-added', refreshCart);
      (function () {
        var _fetch = window.fetch;
        if (!_fetch.__ddCartPatched) {
          window.fetch = function () {
            var a = arguments[0];
            var url = typeof a === 'string' ? a : (a && a.url) || '';
            var res = _fetch.apply(this, arguments);
            if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
              res.then(function () { setTimeout(refreshCart, 50); }).catch(function () {});
            }
            return res;
          };
          window.fetch.__ddCartPatched = true;
        }
      })();
      ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
        document.addEventListener(ev, refreshCart);
      });
    });

    
    /* ---------------- add-to-cart + qty stepper (shared by #dd-new and #dd-best) ---------------- */
    safe('cart-buttons', function () {
      var DD_MAX_QTY = 99;

      function wire(selectorPrefix, container) {
        if (!container) return;
        container.querySelectorAll('.' + selectorPrefix + '-cart').forEach(function (btn) {
          if (btn.disabled) return;
          var id = Number(btn.getAttribute('data-id'));
          var info = btn.parentNode;
          var original = btn.innerHTML;
          var busy = false;

          var step = document.createElement('div');
          step.className = selectorPrefix + '-step';
          step.style.display = 'none';
          step.innerHTML =
            '<button type="button" class="' + selectorPrefix + '-step-btn ' + selectorPrefix + '-minus" aria-label="Decrease">' +
            '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
            '<input class="' + selectorPrefix + '-qty" type="text" inputmode="numeric" pattern="[0-9]*" ' +
            'maxlength="2" value="1" data-qty="0" aria-label="Quantity">' +
            '<button type="button" class="' + selectorPrefix + '-step-btn ' + selectorPrefix + '-plus" aria-label="Increase">' +
            '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
          info.appendChild(step);

          var qtyEl = step.querySelector('.' + selectorPrefix + '-qty');
          var minus = step.querySelector('.' + selectorPrefix + '-minus');
          var plus  = step.querySelector('.' + selectorPrefix + '-plus');

          /* committed = what the cart actually holds right now */
          function committed() { return parseInt(qtyEl.dataset.qty, 10) || 0; }
          function commit(q) { qtyEl.dataset.qty = q; qtyEl.value = q; }

          function showStepper(q) { commit(q); btn.style.display = 'none'; step.style.display = 'flex'; }
          function showButton() { qtyEl.dataset.qty = 0; qtyEl.value = 1; step.style.display = 'none'; btn.style.display = ''; btn.disabled = false; btn.innerHTML = original; }
          function lock(on) { minus.disabled = plus.disabled = on; }

          /* optimistic stepper */
          var target    = null;   
          var syncTimer = null;
          var inFlight  = false;
          var SYNC_MS   = 400;

          function shown() { return target !== null ? target : committed(); }

          function scheduleSync() {
            clearTimeout(syncTimer);
            syncTimer = setTimeout(pushQty, SYNC_MS);
          }

          function pushQty() {
            if (inFlight) { scheduleSync(); return; }
            if (target === null) return;

            var q = target, cur = committed();
            if (q === cur) { target = null; return; }

            inFlight = true;

            var req;
            if (q > cur) {
              req = fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: id, quantity: q - cur })
              });
            } else {
              var body = { updates: {} }; body.updates[id] = q;
              req = fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(body)
              });
            }

            req
              .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
              .then(function (res) {
                if (!res.ok) {
                  console.error('cart update failed:', res.data);
                  target = null; qtyEl.value = committed();
                  return;
                }
                qtyEl.dataset.qty = q;
                if (target === q) {          /* nothing newer queued */
                  target = null;
                  if (q <= 0) showButton();
                } else {
                  scheduleSync();            /* shopper moved on — send again */
                }
                document.dispatchEvent(new CustomEvent('dd:cart-added'));
              })
              .catch(function (err) {
                console.error('cart update error:', err);
                target = null; qtyEl.value = committed();
              })
              .then(function () { inFlight = false; });
          }

          function setQty(q) {
            q = Math.max(0, Math.min(DD_MAX_QTY, q || 0));
            target = q;
            if (q <= 0) {
              step.style.display = 'none';
              btn.style.display = '';
              btn.disabled = false;
              btn.innerHTML = original;
              qtyEl.value = 1;
            } else {
              qtyEl.value = q;
            }
            scheduleSync();
          }

          btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (busy || !id) return;
            busy = true; btn.disabled = true;
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: id, quantity: 1 })
            })
              .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
              .then(function () { showStepper(1); document.dispatchEvent(new CustomEvent('dd:cart-added')); })
              .catch(function () { alert('Could not add to cart. Please try again.'); btn.disabled = false; })
              .then(function () { busy = false; });
          });

          plus.addEventListener('click',  function () { setQty(shown() + 1); });
          minus.addEventListener('click', function () { setQty(shown() - 1); });

          /* ---- typed quantity ---- */
          qtyEl.addEventListener('click', function (e) { e.stopPropagation(); });
          qtyEl.addEventListener('focus', function () { qtyEl.select(); });

          qtyEl.addEventListener('input', function () {
            var v = qtyEl.value.replace(/[^0-9]/g, '').slice(0, 2);       /* digits only, 2 chars => max 99 */
            if (Number(v) > DD_MAX_QTY) v = String(DD_MAX_QTY);
            qtyEl.value = v;
          });

          qtyEl.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); qtyEl.blur(); }        /* commit */
            if (e.key === 'Escape') { qtyEl.value = committed(); qtyEl.blur(); } /* cancel */
          });

          qtyEl.addEventListener('blur', function () {                     /* tap outside = commit */
            var v = parseInt(qtyEl.value, 10);
            if (isNaN(v)) { qtyEl.value = committed(); return; }
            setQty(v);
          });
        });
      }

      wire('dd-new', document.getElementById('ddNewTrack'));
      wire('dd-new', document.getElementById('ddRakhiPanes'));   /* ← was ddRakhiTrack */
      wire('dd-best', document.getElementById('ddBestTrack'));
    });

        /* ---------------- Shop Rakhi Gifts: tabs + shuffle + NEW badge ---------------- */
    safe('rakhi-tabs', function () {
      var sec = document.getElementById('dd-rakhi');
      if (!sec) return;

            /* the modals never relocate themselves here — move them to <body> so
         position:fixed resolves against the viewport, not the card */
            document.querySelectorAll('#dd-rakhi quick-add-modal, #dd-new quick-add-modal, #dd-best quick-add-modal').forEach(function (m) {
        if (m.parentElement !== document.body) document.body.appendChild(m);
      });

      /* fresh order in every pane on every load */
      sec.querySelectorAll('.dd-new-track').forEach(function (track) {
        var cards = Array.prototype.slice.call(track.children);
        for (var i = cards.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          track.appendChild(cards[j]);
          cards.splice(j, 1);
        }
        /* NEW badge on whichever two land first */
        Array.prototype.slice.call(track.children, 0, 2).forEach(function (card) {
          var media = card.querySelector('.dd-new-media');
          if (!media || media.querySelector('.dd-new-new')) return;
          var b = document.createElement('span');
          b.className = 'dd-new-badge dd-new-new';
          b.textContent = 'NEW';
          media.appendChild(b);
        });
      });

            var tabs    = sec.querySelectorAll('.dd-rk-tab');
      var panes   = sec.querySelectorAll('.dd-rk-pane');
      var viewAll = sec.querySelector('.dd-new-all');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-pane');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pane') === key); });

          /* "View all" follows the selected pill */
          var url = tab.getAttribute('data-url');
          if (viewAll && url) viewAll.setAttribute('href', url);
        });
      });

            /* ---- pills row: scroll arrow so people know it's swipeable ---- */
      var tabsRow = sec.querySelector('.dd-rk-tabs');
      if (tabsRow && tabsRow.parentNode) {
        var wrap = document.createElement('div');
        wrap.className = 'dd-rk-tabs-wrap';
        tabsRow.parentNode.insertBefore(wrap, tabsRow);
        wrap.appendChild(tabsRow);

        var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg>';

        ['prev', 'next'].forEach(function (dir) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'dd-rk-tarrow dd-rk-t' + dir;
          btn.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
          btn.innerHTML = ARROW;
          btn.addEventListener('click', function () {
            var step = Math.max(160, tabsRow.clientWidth * 0.6);
            tabsRow.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
          });
          wrap.appendChild(btn);
        });

        var paintTabs = function () {
          var max = tabsRow.scrollWidth - tabsRow.clientWidth - 2;
          wrap.classList.toggle('at-start', tabsRow.scrollLeft <= 2);
          wrap.classList.toggle('at-end', tabsRow.scrollLeft >= max);
          wrap.classList.toggle('no-scroll', max <= 0);
        };
        tabsRow.addEventListener('scroll', paintTabs, { passive: true });
        window.addEventListener('resize', paintTabs);
        paintTabs();
      }
    });


    /* ---------------- homepage cards ⇄ cart sync ----------------*/
    safe('cart-sync-home', function () {
      var DEBOUNCE_MS    = 350;
      var TOUCH_GRACE_MS = 1200;   /* leave a card alone while it's being clicked */
      var POLL_MS        = 1200;
      var POLL_WINDOW    = 45000;

      var timer = null, pollTimer = null, pollUntil = 0, lastTouch = 0;

      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest(
            '.dd-new-cart, .dd-best-cart, .dd-new-step, .dd-best-step')) {
          lastTouch = Date.now();
        }
      }, true);

      function paint(prefix, cart) {
        var qtyBy = {};
        (cart.items || []).forEach(function (it) {
          var id = String(it.variant_id);
          qtyBy[id] = (qtyBy[id] || 0) + it.quantity;
        });

        document.querySelectorAll('.' + prefix + '-cart[data-id]').forEach(function (btn) {
          var info = btn.parentNode;
          if (!info) return;
          var step = info.querySelector('.' + prefix + '-step');
          if (!step) return;                 /* sold-out cards have no stepper */

          var qtyEl = step.querySelector('.' + prefix + '-qty');
          var qty   = qtyBy[String(btn.getAttribute('data-id'))] || 0;

          if (qtyEl && document.activeElement === qtyEl) return;

          if (qty > 0) {
            btn.style.display = 'none';
            step.style.display = 'flex';
            if (qtyEl) { qtyEl.dataset.qty = qty; if (qtyEl.value !== String(qty)) qtyEl.value = qty; }  /* ← changed */
          } else {
            step.style.display = 'none';
            btn.style.display = '';
            btn.disabled = false;
            if (qtyEl) { qtyEl.dataset.qty = 0; qtyEl.value = '1'; }   /* ← changed */
          }
        });
      }

      function run() {
        if (Date.now() - lastTouch < TOUCH_GRACE_MS) return;
        fetch('/cart.js', {
          headers: { 'Accept': 'application/json' },
          cache: 'no-store',
          credentials: 'same-origin'
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart) return;
            paint('dd-new', cart);
            paint('dd-best', cart);
          })
          .catch(function () {});
      }

      function sync(now) {
        clearTimeout(timer);
        timer = setTimeout(run, now ? 0 : DEBOUNCE_MS);
      }

      function startPoll() {
        pollUntil = Date.now() + POLL_WINDOW;
        if (pollTimer) return;
        pollTimer = setInterval(function () {
          if (Date.now() > pollUntil || document.visibilityState !== 'visible') {
            clearInterval(pollTimer); pollTimer = null; return;
          }
          run();
        }, POLL_MS);
      }

      /* the fetch patch in the cart-count block already fires dd:cart-added
         indirectly via refreshCart; listen to the same signals here */
      ['cart:updated', 'cart:refresh', 'cart:change', 'dd:cart-added']
        .forEach(function (ev) { document.addEventListener(ev, function () { sync(); }); });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); }); } catch (e) {}
      }

      /* catch drawer edits directly, plus a bounded poll while the cart is open */
      (function () {
        var orig = window.fetch;
        if (typeof orig !== 'function' || orig.__ddHomeSync) return;
        var RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
        window.fetch = function () {
          var a = arguments[0];
          var url = typeof a === 'string' ? a : (a && a.url) || '';
          var res = orig.apply(this, arguments);
          if (RE.test(url)) {
            try { res.then(function () { sync(); }).catch(function () {}); } catch (e) {}
          }
          return res;
        };
        window.fetch.__ddHomeSync = true;
      })();

      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('#cart-icon-bubble, .dd-hd-cart, a[href$="/cart"]')) {
          startPoll(); sync();
        }
      }, true);

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') sync(true);
      });
      window.addEventListener('pageshow', function () { sync(true); });

      sync(true);   /* initial paint — restores steppers on reload */
    });

    /* ---------------- search dropdown panel ---------------- */
    safe('searchpanel', function () {
      var input = document.getElementById('ddHdInput');
      var goBtn = document.getElementById('ddHdGo');
      var p = document.getElementById('ddSearchPanel');
      var grid = document.getElementById('ddSpGrid');
      if (!input || !p || !grid) return;

      function go() {
        var term = input.value.trim();
        window.location.href = '/pages/search?q=' + encodeURIComponent(term);
      }
      if (goBtn) goBtn.addEventListener('click', go);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });

      function money(v) {
        var n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[^0-9.]/g, ''));
        if (isNaN(n)) return '';
        return '\u20B9' + n.toFixed(2);
      }
      function stars(r) {
        var full = Math.round(r || 4), s = '';
        for (var i = 1; i <= 5; i++) {
          s += '<svg class="dd-sp-star' + (i <= full ? ' on' : '') + '" viewBox="0 0 24 24">' +
               '<polygon points="12 2 15.1 8.6 22 9.5 17 14.3 18.2 21 12 17.8 5.8 21 7 14.3 2 9.5 8.9 8.6"/></svg>';
        }
        return s;
      }
      function card(pr) {
        return '<a class="dd-sp-card" href="' + pr.url + '">' +
                 '<div class="dd-sp-img">' + (pr.img ? '<img src="' + pr.img + '" alt="" loading="lazy">' : '') + '</div>' +
                 '<div class="dd-sp-price">' + money(pr.price) +
                   (pr.compare && parseFloat(pr.compare) > parseFloat(pr.price) ? '<s>' + money(pr.compare) + '</s>' : '') +
                 '</div>' +
                 '<div class="dd-sp-stars">' + stars(pr.rating) + '</div>' +
                 '<div class="dd-sp-title">' + pr.title + '</div>' +
               '</a>';
      }
      function render(list) {
        if (!list.length) { grid.innerHTML = '<div class="dd-sp-empty">No products found</div>'; return; }
        grid.innerHTML = list.slice(0, 6).map(card).join('');
      }
      function skeleton() {
        grid.innerHTML = new Array(6).join('x').split('x').map(function () { return '<div class="dd-sp-skel"></div>'; }).join('');
      }

      var defaultCache = null;
      /* Shopify fallback — used if Wizzy hasn't loaded or its API errors */
      function loadDefaultsShopify() {
        fetch('/collections/top-products-search/products.json?limit=6', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var fallback = (d.products || []).slice(0, 6).map(function (x) {
              var v = (x.variants && x.variants[0]) || {};
              return { title: x.title, url: '/products/' + x.handle, img: (x.images && x.images[0] && x.images[0].src) || '', price: v.price, compare: v.compare_at_price, rating: 4 };
            });
            render(fallback);
          })
          .catch(function () { grid.innerHTML = ''; });
      }

      function loadDefaults() {
        if (defaultCache) { render(defaultCache); return; }
        skeleton();

        var cfg  = window.wizzyConfig || {};
        var cred = cfg.credentials || {};
        var pool = (((cfg.autocomplete || {}).configs || {}).defaultBehaviour || {}).topProducts || {};
        var filters = (pool.defaultPool || {}).data;

        /* Wizzy not ready → keep the old behaviour */
        if (!cred.apiKey || !cred.storeId || !filters) { loadDefaultsShopify(); return; }

        fetch('https://api.wizsearch.in/v1/products/filter', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/json',
            'X-Api-Key': cred.apiKey,
            'X-Store-Id': cred.storeId
          },
          body: JSON.stringify({ filters: JSON.stringify(filters), group: 'defaultMenu' })
        })
          .then(function (r) { if (!r.ok) throw new Error('wizzy ' + r.status); return r.json(); })
          .then(function (d) {
            var list = ((d.payload || {}).result) || [];
            if (!list.length) throw new Error('wizzy empty');
            defaultCache = list.slice(0, 6).map(function (x) {
              return {
                title:   x.name,
                url:     x.url,
                img:     x.mainImage || '',
                price:   x.sellingPrice,
                compare: x.price,
                rating:  x.avgRatings ? (x.avgRatings / 20) : 4   /* avgRatings is 0-100 */
              };
            });
            render(defaultCache);
          })
          .catch(function () { loadDefaultsShopify(); });
      }

      var t = null;
      function suggest(q) {
        skeleton();
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = ((d.resources || {}).results || {}).products || [];
            render(items.map(function (x) {
              return { title: x.title, url: x.url, img: x.featured_image ? x.featured_image.url : '', price: x.price, compare: x.compare_at_price, rating: 4 };
            }));
          })
          .catch(function () {});
      }

      var isOpen = false;
      function open() { if (isOpen) return; isOpen = true; p.classList.add('is-open'); if (!input.value.trim()) loadDefaults(); }
      function close() { if (!isOpen) return; isOpen = false; p.classList.remove('is-open'); }

      input.addEventListener('focus', open);
      input.addEventListener('click', open);
      input.addEventListener('input', function () {
        open();
        var q = input.value.trim();
        clearTimeout(t);
        if (q.length < 2) { loadDefaults(); return; }
        t = setTimeout(function () { suggest(q); }, 220);
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
      document.addEventListener('pointerdown', function (e) {
        var wrap = document.querySelector('.dd-hd-search');
        if (wrap && !wrap.contains(e.target)) close();
      });
    });

    /* ---------------- search panel: left column from Wizzy ---------------- */
    safe('searchpanel-left', function () {
      var panel = document.getElementById('ddSearchPanel');
      var input = document.getElementById('ddHdInput');
      if (!panel || !input) return;

      var left = panel.querySelector('.dd-sp-left');
      if (!left) return;

      var painted = false;

      function paintLeft() {
        if (painted) return;

        var cfg  = window.wizzyConfig || {};
        var ac   = cfg.autocomplete || {};
        var menu = ac.menu || {};
        var pool = ((((ac.configs || {}).defaultBehaviour || {}).suggestions || {}).defaultPool) || [];

        /* Wizzy not ready → leave the server-rendered markup alone, retry next open */
        if (!pool.length) return;

        var order = (menu.sections && menu.sections.length) ? menu.sections : ['others', 'categories'];
        var frag  = document.createDocumentFragment();

        order.forEach(function (key) {
          var items = pool.filter(function (x) { return x.section === key; });
          if (!items.length) return;

          var title = (menu[key] && menu[key].title) || key;

          var h = document.createElement('div');
          h.className = 'dd-sp-h';
          h.textContent = title;
          frag.appendChild(h);

          var list = document.createElement('div');
          list.className = 'dd-sp-list';
          items.forEach(function (x) {
            var a = document.createElement('a');
            a.href = '/pages/search?q=' + encodeURIComponent(x.value);
            a.textContent = x.value;
            list.appendChild(a);
          });
          frag.appendChild(list);
        });

        if (!frag.childNodes.length) return;

        left.innerHTML = '';
        left.appendChild(frag);
        painted = true;
      }

      input.addEventListener('focus', paintLeft);
      input.addEventListener('click', paintLeft);
      paintLeft();   /* in case Wizzy is already up */
    });

  });
})();


/*  Rakhi card ⇄ cart sync */
(function () {
  var CARD_SEL       = '.grid.product-grid > li .card-coll-new';
  var CART_URL_RE    = /\/cart\/(add|change|update|clear)(\.js)?/i;
  var DEBOUNCE_MS    = 350;
  var TOUCH_GRACE_MS = 1200;   /* hands off a card the shopper is clicking */
  var POLL_MS        = 1200;
  var POLL_WINDOW    = 45000;

  var timer = null, pollTimer = null, pollUntil = 0, lastTouch = 0;

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.cp-qty, .card-coll-new .quick-add__submit')) {
      lastTouch = Date.now();
    }
  }, true);

  /* function resync() {
    if (Date.now() - lastTouch < TOUCH_GRACE_MS) return;   /* mid-interaction * /
    try {
      document.querySelectorAll(CARD_SEL).forEach(function (card) {
        card._cpPending = false;
      });
      crowai_cardQtyStepper_cp01();   /* re-runs refreshCart() + renderAll() * /
    } catch (e) {}
  } */
    function resync() {
    if (Date.now() - lastTouch < TOUCH_GRACE_MS) return;
    try {
      /* refreshCart() only clears _cpPending when qty > 0, so after a full
         removal cardQty() keeps returning the optimistic data-cp-qty and the
         stepper never reverts to ADD TO CART. Clear it first. */
      document.querySelectorAll('.card-coll-new').forEach(function (card) {
        card._cpPending = false;
      });

      /* PDP: drive the live closure through its exposed refresh */
      if (typeof window.rkPdpRefreshCartQty === 'function') {
        window.rkPdpRefreshCartQty();
      }

      /* PLP: unchanged — this already works */
      if (typeof crowai_cardQtyStepper_cp01 === 'function') {
        crowai_cardQtyStepper_cp01();
      }
    } catch (e) {}
  }

  function sync(now) {
    clearTimeout(timer);
    timer = setTimeout(resync, now ? 0 : DEBOUNCE_MS);
  }

  function startPoll() {
    pollUntil = Date.now() + POLL_WINDOW;
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (Date.now() > pollUntil || document.visibilityState !== 'visible') {
        clearInterval(pollTimer); pollTimer = null; return;
      }
      resync();
    }, POLL_MS);
  }

  /* cart mutations made via fetch (Dawn's drawer uses this) */
  (function () {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__cpRakhiSync) return;
    window.fetch = function () {
      var a = arguments[0];
      var url = typeof a === 'string' ? a : (a && a.url) || '';
      var res = orig.apply(this, arguments);
      if (CART_URL_RE.test(url)) {
        try { res.then(function () { sync(); }).catch(function () {}); } catch (e) {}
      }
      return res;
    };
    window.fetch.__cpRakhiSync = true;
  })();

  /* ...and via XHR, for apps that don't use fetch */
  (function () {
    var p = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!p || p.__cpRakhiSync) return;
    var oOpen = p.open, oSend = p.send;
    p.open = function (m, u) { try { this.__cpUrl = u; } catch (e) {} return oOpen.apply(this, arguments); };
    p.send = function () {
      try {
        if (CART_URL_RE.test(this.__cpUrl || '')) {
          this.addEventListener('loadend', function () { sync(); });
        }
      } catch (e) {}
      return oSend.apply(this, arguments);
    };
    p.__cpRakhiSync = true;
  })();

  ['cart:updated', 'cart:refresh', 'cart:change', 'dd:cart-added'].forEach(function (ev) {
    document.addEventListener(ev, function () { sync(); });
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { sync(); }); } catch (e) {}
  }

  /* opening the cart starts a bounded watch, as a fallback */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble, .dd-hd-cart, a[href$="/cart"]')) {
      startPoll(); sync();
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') sync(true);
  });
  window.addEventListener('pageshow', function () { sync(true); });
})();
